import { Monitor } from 'lucide-react';
import styles from './AvisoTelaComputador.module.css';

/**
 * Aviso das telas que nao foram adaptadas ao celular. So aparece ate 768px;
 * no desktop fica oculto e nao ocupa espaco.
 */
export function AvisoTelaComputador() {
  return (
    <p className={styles.aviso} role="note">
      <Monitor size={22} aria-hidden className={styles.icone} />
      Esta tela funciona melhor no computador.
    </p>
  );
}
